/* vt-home-void.js v7 — 2026-08-14 (CC)
 *
 * TOPとVol.11商品ページの「Turn the pages」— 写真集を実際にめくるセクション。
 * 表紙 → 扉 → ステートメント → 目次 → 14人の最初の見開き → 奥付 → 裏表紙。
 *
 * v6 → v7 (2026-08-14 かわら指示):
 *  ・「最初の1めくりが早すぎる。タップかNextまで表紙のままに」
 *    → 画面に入ったときの自動めくり（200ms後に1ページ）を完全に廃止。
 *    読者が自分でめくるまで何も動かない。IntersectionObserverは
 *    矢印キー用の「画面内にあるか」判定としてだけ残す。
 *  ⚠️ TOPの本と商品ページの本の両方に効く（共通エンジン）。
 * v5 → v6: at-start / at-end で端の空白紙を消す。
 * v4 → v5: めくりを速く（620ms → 340ms）。作家名表示。
 *
 * かわらの原則（2026-08-14更新）：自動では一切めくらない。めくるのは読者だけ。
 */
(function () {
  function initTurn(root) {
    var book = root.querySelector('[data-book]');
    if (!book) return;
    var pages = Array.prototype.slice.call(book.querySelectorAll('[data-page]'));
    if (!pages.length) return;

    var TOTAL = pages.length;
    var names = (book.getAttribute('data-names') || '').split('|');
    var counter = root.querySelector('[data-turn-i]');
    var nameEl = root.querySelector('[data-turn-name]');
    var prevBtn = root.querySelector('[data-turn="prev"]');
    var nextBtn = root.querySelector('[data-turn="next"]');
    var cur = 0;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function paint() {
      for (var i = 0; i < pages.length; i++) {
        var el = pages[i];
        var idx = Number(el.getAttribute('data-page'));
        var flipped = idx < cur;
        el.style.transform = flipped ? 'rotateY(-179deg)' : 'rotateY(0deg)';
        el.style.zIndex = String(flipped ? idx + 1 : TOTAL - idx);
      }
      // 表紙／裏表紙のときは、ページの無い側を消す
      book.classList.toggle('at-start', cur === 0);
      book.classList.toggle('at-end', cur === TOTAL);
      if (counter) counter.textContent = pad(cur + 1);
      if (nameEl && names[cur]) nameEl.textContent = names[cur];
      if (prevBtn) prevBtn.disabled = (cur === 0);
      if (nextBtn) nextBtn.disabled = (cur === TOTAL);
    }

    function step(d) {
      var n = cur + d;
      if (n < 0) n = 0;
      if (n > TOTAL) n = TOTAL;
      if (n === cur) return;
      cur = n;
      paint();
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });

    book.addEventListener('click', function (e) {
      var b = book.getBoundingClientRect();
      step(e.clientX - b.left > b.width / 2 ? 1 : -1);
    });

    var inView = false;
    document.addEventListener('keydown', function (e) {
      if (!inView) return;
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });

    var x0 = null;
    book.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    book.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 34) step(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0.45 }).observe(book);
    }

    paint();
  }

  function boot() {
    var roots = document.querySelectorAll('.vhv');
    for (var i = 0; i < roots.length; i++) initTurn(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.vhv');
    if (r) initTurn(r);
  });
})();
